import { observable, action, flow } from "mobx";
import { MensagemModel, AnexoModel, EncontroPresencial, OrientacaoModel, PagedRequest } from "./Model";
import { apiState, apiResponse } from "../../Api";
import { RootStore } from '../createStore';
import { sendMessageAPI, sendRegistroEncontroPresencialAPI, fetchMessages, fetchOrientacoes, fetchFile } from './Service'

export class ChatStore {
  @observable public mensagens: MensagemModel[] = [];
  @observable public anexoList: { [anexoId: string]: { anexo: AnexoModel, requestStatus: apiState } } = {};
  @observable public toDownload?: AnexoModel;
  @observable public novaMensagem: {
    texto?: string,
    anexo?: File,
    aluno?: number,
    enviarEmail?: boolean
  } = {};
  @observable encontroPresencial: EncontroPresencial = {};
  @observable apiStates: {
    getMensagensState?: apiState;
    getOrientacoesState?: apiState;
    orientacoesListRequest?: apiResponse<OrientacaoModel[]>;
  } = {};
  @observable orientacoesList: OrientacaoModel[] = [];
  @observable queries: { [nome: string]: PagedRequest } = {
    mensagens: new PagedRequest({
      search: '',
      page: 0,
      pageSize: 10
    }),
    orientacoes: new PagedRequest({
      search: '',
      page: 0,
      pageSize: 10
    })
  }
  @observable carregouTodasOrientacoes: boolean = false;
  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  getAnexo = flow(function* (
    this: ChatStore,
    id: string
  ) {
    let response;

    if ((this.anexoList[id] == undefined) || !this.anexoList) {
      response = yield fetchFile(id);
      this.anexoList[id] = response;

    } else {
      response = this.anexoList[id];
    }

    const urlDownload = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = urlDownload;
    link.setAttribute('download', `${id}.${this.mensagens.find(m => m.anexos[0] && m.anexos[0].id === id)!.anexos[0].extensao}`);
    document.body.appendChild(link);
    link.click();
  });

  @action
  getMensagens = flow(function* (
    this: ChatStore,
    dynamicArgs: ['aluno'] | ['professor', number],
    concat: boolean = true,
    paginacao?: PagedRequest
  ) {
    const isForcedPagination = Boolean(paginacao);

    if (paginacao == undefined) {
      paginacao = this.queries['mensagens'];
      this.queries['mensagens'].nextPage();
    }

    this.apiStates.getMensagensState = apiState.loading;

    const mensagens = yield fetchMessages(
      paginacao.eval(),
      dynamicArgs[0],
      dynamicArgs[1]
    );

    this.apiStates.getMensagensState = concat && mensagens.data.length < paginacao.pageSize ? apiState.noContent : mensagens.status;

    this.mensagens = concat
      ? (!isForcedPagination
        ? [...this.mensagens, ...mensagens.data]
        : [...mensagens.data, ...this.mensagens]
          .filter((m, i, arr) => arr.map(m => m.id).indexOf(m.id) === i)
          .sort((m) => m.enviadoEm.valueOf())
      )
      : mensagens.data;
  });

  @action
  getOrientacoes = flow(function* (
    this: ChatStore,
    concat: boolean = true,
    paginacao?: PagedRequest
  ) {
    const isForcedPagination = Boolean(paginacao);

    if (paginacao == undefined) {
      paginacao = this.queries['orientacoes'];
      this.queries['orientacoes'].nextPage();
    }

    this.apiStates.getOrientacoesState = apiState.loading;

    const orientacoes = yield fetchOrientacoes(paginacao.eval());

    this.apiStates.getOrientacoesState = orientacoes.status;

    if (!orientacoes.data) {
      this.carregouTodasOrientacoes = true
    }

    this.orientacoesList = concat
      ? (!isForcedPagination
        ? [...this.orientacoesList, ...orientacoes.data]
          .filter((m, i, arr) => arr.map(o => o.aluno.id).indexOf(m.aluno.id) === i)
        : [...orientacoes.data, ...this.orientacoesList]
          .filter((m, i, arr) => arr.map(o => o.aluno.id).indexOf(m.aluno.id) === i)
      )
      : orientacoes.data;
  })

  @action
  sendMensagem = flow(function* (this: ChatStore, dynamicArgs: ['aluno'] | ['professor', number]) {
    if (dynamicArgs[0] == 'professor') this.novaMensagem.aluno = dynamicArgs[1];
    const result = yield sendMessageAPI(this.novaMensagem);
    if (result.status == apiState.done) {
      this.novaMensagem = {};
    }
  })

  @action
  sendRegistroDeEncontroPresencial = flow(function* (this: ChatStore, alunoId: number) {
    this.encontroPresencial.alunoId = alunoId;
    const result = yield sendRegistroEncontroPresencialAPI(this.encontroPresencial);
    if (result.status == apiState.done) {
      this.encontroPresencial = {};
    }
  });

  @action
  updateMessageAttribute = (name: string, value: any) => {
    this.novaMensagem[name] = value;
  };

  @action
  updateAttributeEncontroPresencial = (name: string, value: any) => {
    this.encontroPresencial[name] = value;
  };


}